// extracted by mini-css-extract-plugin
export default {"grayContainer":"EditContactDetails_grayContainer__NPheb","contactListContainer":"EditContactDetails_contactListContainer__1M2oy"};